import React from 'react';
import { ClipPath, Defs, G, Path, Svg, Rect } from 'react-native-svg';
import { rem } from 'design-system/values';
import useColors from 'hooks/useColors';
const IconProhibition = () => {
    const colors = useColors();
    const width = rem(54);
    const height = rem(54);
    return (<Svg width={width} height={height} viewBox="0 0 54 54" fill="none">
      <G clipPath="url(#clip0_201_19522)">
        <Path fill={colors.elements.negative} d="M27.0148 0.000228882C12.442 0.000228882 0.5 11.9423 0.5 26.5151C0.5 41.0879 12.442 53.0299 27.0148 53.0299C41.5876 53.0299 53.5297 41.0879 53.5297 26.5151C53.5297 11.9423 41.5876 0.000228882 27.0148 0.000228882ZM6.81799 26.5151C6.81799 15.3912 15.8909 6.31822 27.0148 6.31822C31.2095 6.31822 35.249 7.62314 38.6979 10.0778L27.0148 21.7609L10.5778 38.1982C8.12291 34.7491 6.81799 30.7097 6.81799 26.5151ZM27.0148 46.7119C22.8202 46.7119 18.7806 45.4068 15.3317 42.9521L43.452 14.8319C45.9068 18.2809 47.2117 22.3202 47.2117 26.5151C47.2117 37.6388 38.1387 46.7119 27.0148 46.7119Z"/>
        <Path fill={colors.elements.negative} d="M53.5294 26.5151C53.5294 41.0879 41.5874 53.0299 27.0146 53.0299V46.7119C38.1385 46.7119 47.2114 37.6388 47.2114 26.5151C47.2114 22.3202 45.9065 18.2809 43.4516 14.832L27.0146 31.269V21.7609L38.6977 10.0778C35.2488 7.62314 31.2092 6.31822 27.0146 6.31822V0.000228882C41.5874 0.000228882 53.5294 11.9423 53.5294 26.5151Z"/>
      </G>
      <Defs>
        <ClipPath id="clip0_201_19522">
          <Rect width="53.0297" height="53.0297" fill="white" transform="translate(0.5)"/>
        </ClipPath>
      </Defs>
    </Svg>);
};
export default IconProhibition;
